import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "#215f69",
      rx: "4"
    }, null, -1),
    _createElementVNode("rect", {
      width: "8",
      height: "2",
      x: "4",
      y: "7",
      fill: "#fff",
      rx: "1"
    }, null, -1)
  ]))]))
}
export default { render: render }